<template>
  <v-row no-gutters class="justify-space-between">
    <v-col
      cols="4"
      class="sidebar-select-row-text text-left"
      :class="disabled ? 'text--disabled' : ''"
      style="font-size: 14px"
    >
      {{ $i18n.t(translationPath) }}:
    </v-col>
    <v-col cols="7" class="text-left">
      <v-menu
        ref="menu"
        v-model="menu"
        v-bind="menuProps"
        :close-on-content-click="false"
        :return-value.sync="computedValue"
        transition="scale-transition"
        offset-y
        offset-x
        nudge-right="-300"
        bottom
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <data-input
            :data-type="{ name: 'text' }"
            :value="formattedDataType"
            readonly
            :disabled="disabled"
            v-bind="{ ...attrs, ...inputProps }"
            v-on="on"
          >
            <template #prepend>
              <v-icon :color="disabled ? 'rgba(0, 0, 0, 0.26)' : 'rgba(0,0,0,0.7)'" size="24"> mdi-calendar </v-icon>
            </template>
          </data-input>
        </template>
        <v-date-picker v-model="computedValue" range no-title scrollable :type="type" :disabled="disabled">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">
            {{ $i18n.t('dialog.disagree') }}
          </v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(computedValue)">
            {{ $i18n.t('dialog.agreeSave') }}
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import DataInput from '@/components/DataInput';
export default {
  name: 'SidebarDatePickerRow',
  components: { DataInput },
  props: {
    translationPath: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    menuProps: {
      type: Object,
      default: () => {},
    },
    inputProps: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'month',
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        if (nV.length > 1) {
          const date1 = this.$dayjs(nV[0]);
          const date2 = this.$dayjs(nV[1]);
          if (date2.isBefore(date1)) {
            this.$emit('input', [nV[1], nV[0]]);
            return;
          }
        }
        this.$emit('input', nV);
      },
    },

    formattedDataType() {
      return this.computedValue ? this.computedValue.join(' - ') : '';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-input__slot {
    margin-bottom: 3px;
    input {
      padding: 0px;
    }
    label {
      top: 0px;
    }
  }
  .v-input__prepend-outer .v-icon {
    color: black;
    font-size: 32px;
  }
  .v-input {
    font-size: 12px;
  }
  .v-input--is-disabled .v-input__control .v-input__slot {
    cursor: default;
  }
  .theme--light.v-input--is-disabled input {
    cursor: default;
  }
}
.v-input {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
}
.v-picker {
  border-radius: 0px;
}
</style>
